import React from "react";
import { UI_THEME as THEME } from "../common/UiTheme";

// 지도 위/아래에 배치할 안전정보 호출 버튼
function SafetyInfoButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${THEME.btnBase} ${THEME.btnSecondary} gap-2`}
    >
      <span className="w-5 h-5 rounded-md border border-gray-800 flex items-center justify-center text-[10px] font-bold">
        S
      </span>
      <span>안전정보 보기</span>
    </button>
  );
}

export default SafetyInfoButton;
